import PropertyCountryBadge from './PropertyCountryBadge';
export default PropertyCountryBadge;
